<template>
  <div class="loginRequiredContainer">
    <div class="header">
      <p class="title">{{ $t('flipCoinLoginRequiredTitle') }}</p>
      <img class="close" src="/img/icons/bone_close.svg" alt="close" @click="getOut" />
    </div>
    <div class="body">
      <p class="result">{{ $t('flipCoinYouNeedToLogIn') }}</p>

      <div class="buttons">
        <TavernFlipCoinBigButton class="getOutBtn" label="OK" @click="getOut" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['go-to-stats', 'get-out']);

const getOut = () => {
  emit('get-out');
};
</script>

<style lang="scss" scoped>
.loginRequiredContainer {
  width: min-content;
  border-radius: 12px;
  background: linear-gradient(to bottom, #4e3127, #000000);
  margin: 0 auto;
  padding: 20px 30px;
  padding-top: 7px;
  margin-top: 7%;
  z-index: 9999;
  position: relative;
  min-width: 460px;
  border: 1px solid #483b20;
  @media screen and (max-width: 479px) {
    position: fixed;
    width: 99vw;
    margin-top: 0;
    left: 0;
    min-width: unset;
  }
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;

  .title {
    font-size: 32px;
    line-height: 32px;
    font-weight: 700;
    font-family: Grenze, sans-serif;
    color: #fff;
    white-space: nowrap;
    text-align: center;
    width: 100%;
    padding: 0 30px;
  }

  .close {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}

.body {
  text-align: center;
  font-size: 20px;
  color: #fff;
}

.result {
  font-weight: 500;
}

.buttons {
  display: flex;
  justify-content: center;
  margin-top: 12px;

  button {
    flex-basis: 0.5;
    height: 48px;
  }

  .getOutBtn {
    margin: 0px;
    margin-left: 10px;
    line-height: 24px;
  }
}
</style>
